import vitaIcon from '../assets/vita-icon.png';

function SplashScreen() {
  return (
    <div style={styles.container}>
      <div style={styles.glow}></div>

      <img
        src={vitaIcon}
        alt="VITA"
        style={styles.logo}
      />

      <h1 style={styles.title}>
        VITA
      </h1>

      <p style={styles.subtitle}>
        Territorial Intelligence
      </p>

      <div style={styles.loader}>
        <div style={styles.loaderBar}></div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    position: 'fixed',
    inset: 0,

    background:
      'radial-gradient(circle at top,#0b2a52 0%,#071a2f 45%,#04101d 100%)',

    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',

    zIndex: 9999,

    overflow: 'hidden'
  },

  glow: {
    position: 'absolute',

    width: '420px',
    height: '420px',

    borderRadius: '50%',

    background:
      'radial-gradient(circle,rgba(9,147,181,0.24),transparent 70%)',

    filter: 'blur(30px)'
  },

  logo: {
    width: '160px',
    height: '160px',

    objectFit: 'contain',

    zIndex: 2,

    marginBottom: '-10px',

    animation: 'float 3s ease-in-out infinite'
  },

  title: {
    color: 'white',

    fontSize: '68px',
    fontWeight: '900',

    letterSpacing: '3px',

    margin: 0,

    zIndex: 2
  },

  subtitle: {
    color: 'rgba(255,255,255,0.72)',

    fontSize: '16px',

    letterSpacing: '2px',

    marginTop: '8px',

    textTransform: 'uppercase',

    zIndex: 2
  },

  loader: {
    width: '220px',
    height: '6px',

    background: 'rgba(255,255,255,0.08)',

    borderRadius: '999px',

    overflow: 'hidden',

    marginTop: '34px',

    zIndex: 2
  },

  loaderBar: {
    width: '60%',
    height: '100%',

    borderRadius: '999px',

    background:
      'linear-gradient(90deg,#1fa97a,#0993b5)',

    animation: 'loading 1.2s ease-in-out infinite'
  }
};

export default SplashScreen;